import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useEffect, useRef } from 'react';
import { useMediaQuery } from 'react-responsive';

import img from '@/assets/images/about.webp';
import { ReactComponent as Logos } from '@/assets/images/logos-about.svg';

import styles from './About.module.scss';

function About() {
  gsap.registerPlugin(ScrollTrigger);
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  const textRef = useRef([]);
  const textColorRef = useRef(null);
  const textSizeRef = useRef(null);
  const containerTextColorRef = useRef(null);

  useEffect(() => {
    const mm = gsap.matchMedia();
    const chars = textRef.current;

    if (containerTextColorRef.current && textRef.current && textSizeRef.current) {
      const triggerContainerTextColor = containerTextColorRef.current;
      const totalChars = chars.length;

      chars.forEach((char, index) => {
        ScrollTrigger.create({
          trigger: triggerContainerTextColor,
          start: '15% bottom',
          end: 'center bottom',
          markers: false,
          onUpdate: (self) => {
            const progress = self.progress;
            const charProgress = index / totalChars;
            if (progress > charProgress) {
              gsap.to(char, { color: '#000000' }); // Черный
            } else {
              gsap.to(char, { color: '#E2E2E2' }); // Серый
            }
          },
          scrub: true,
        });
      });

      const scrollTriggerVars = {
        trigger: triggerContainerTextColor,
        start: '85% bottom',
        end: 'bottom top',
        markers: false,
        toggleActions: 'play none none reverse',
      };

      const tl = gsap.timeline({
        scrollTrigger: {
          ...scrollTriggerVars,
        },
      });

      const t2 = gsap.timeline({
        scrollTrigger: {
          ...scrollTriggerVars,
          start: '95% bottom',
        },
      });

      mm.add('(min-width: 769px)', () => {
        tl.fromTo(textSizeRef.current, { fontSize: '20px' }, { fontSize: '52px' });
      });

      mm.add('(max-width: 768px)', () => {
        t2.fromTo(textSizeRef.current, { fontSize: '6px' }, { fontSize: '24px' });
      });

      return () => {
        ScrollTrigger.getAll().forEach(trigger => trigger.kill());
      };
    }
  }, [isMobile]);

  const title = 'Девятый всероссийский полумарафон с синхронным стартом';
  const splitText = title.split('');

  return (
    <section className={styles.about} ref={containerTextColorRef}>
      <h2 className={styles.title} ref={textColorRef}>
        {splitText.map((char, i) => (
          <span ref={el => textRef.current[i] = el} key={i} style={{ transition: 'color 0.1s' }}>
            {char}
          </span>
        ))}
      </h2>
      <p className={styles.subtitle}>Первый забег прошёл 21 мая 2017 года</p>

      <Logos className={styles.logos} />

      <div className={styles.imgWrap}>
        <img className={`${styles.img} lazyload`} src={img} width={690} height={480} alt="Участники Всероссийского полумарафона ЗаБег.РФ" />

        <p className={styles.desc} ref={textSizeRef}>
          Сегодня это уже не просто <br /> полумарафон — это международный <br /> легкоатлетический праздник
        </p>
      </div>
    </section>
  );
}

export default About;
